import { NgModule } from '@angular/core';
import { ListFilterComponent } from './list-filter.component';

import { InputComponent } from './controlcomponent/inputcomponent/input.component';
import { SearchComponent } from './controlcomponent/searchcomponent/search.component';
import { HelpComponent } from './controlcomponent/helpcomponent.ts/help.component';
import { DateComponent } from './controlcomponent/datecomponent/date.component';
import { DropDownComponent } from './controlcomponent/dropdowncomponent/dropdown.component';
import { NumberComponent } from './controlcomponent/numbercomponent/number.component';
import { FilterCheckboxComponent } from './controlcomponent/checkboxcomponent/checkbox.component';
import { DateRangeComponent } from './controlcomponent/daterangecomponent/daterange.component';
import { ComboLookUpComponent } from './controlcomponent/combolookupcomponent/combolookup.component';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputGroupModule } from '@farris/ui-input-group';
import { FarrisDatePickerModule } from '@farris/ui-datepicker';
import { DatalistModule } from '@farris/ui-datalist';
import { ComboListModule } from '@farris/ui-combo-list';
import { LookupModule } from '@farris/ui-lookup';
import { FarrisFormsModule } from '@farris/ui-forms';
import { PerfectScrollbarModule } from '@farris/ui-perfect-scrollbar';
import { ComboLookupModule } from '@farris/ui-combo-lookup';
// import { InputsModule } from '@progress/kendo-angular-inputs';
import { SolutionService } from './service/solution.service';
import { NumberSpinnerModule } from '@farris/ui-number-spinner';

import { QuerySolutionService } from './submithandlers/query-solution.service';
import { ConvertorService } from './service/convertorservice';
import { ListFilterCommonComponent } from './list-filter-common';

import { LocaleModule } from '@farris/ui-locale';
import { ControlTypeXPipe } from './controlType.pipe';
import { FilterRadioComponent } from './controlcomponent/radiocomponent/radio.component';
import { FilterInputGroupComponent } from './controlcomponent/inputgroupcomponent/inputgroup.component';
import { ClearFieldsDirective } from './directives/clear-fields.directive';

@NgModule({
  declarations: [
    ListFilterComponent,
    DateComponent,
    NumberComponent,
    HelpComponent,
    InputComponent,
    DropDownComponent,
    SearchComponent,
    FilterCheckboxComponent,
    DateRangeComponent,
    ListFilterCommonComponent,
    FilterRadioComponent,
    FilterInputGroupComponent,
    ComboLookUpComponent,
    ControlTypeXPipe,
    ClearFieldsDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    InputGroupModule,
    FarrisDatePickerModule,
    DatalistModule,
    ComboListModule,
    LookupModule,
    FarrisFormsModule,
    NumberSpinnerModule,
    PerfectScrollbarModule,
    ComboLookupModule,
    LocaleModule.forRoot()
    // InputsModule
  ],
  providers:[
    ConvertorService,
    SolutionService,
    QuerySolutionService
  ],
  exports: [
    ListFilterComponent,
    DateComponent,
    NumberComponent,
    HelpComponent,
    InputComponent,
    DropDownComponent,
    SearchComponent,
    FilterCheckboxComponent,
    DateRangeComponent,
    ListFilterCommonComponent,
    FilterRadioComponent,
    FilterInputGroupComponent,
    ControlTypeXPipe
  ]
})
export class ListFilterModule { }
